<div>
  <div *ngIf="view === 'groups'">
    <lms-toolbar [options]="toolbarConfig" (clickDownload)="downloadReport()">
      <gl-context-menu medium>
        <gl-button slot="target" icon icon-center="glicon-download"> </gl-button>
        <gl-menu-item
          [text]="'kepler.ranking.rankingExportCurrentList' | translate"
          (click)="downloadReport()"
        ></gl-menu-item>
        <gl-menu-item
          [text]="'kepler.ranking.rankingExportAllList' | translate"
          (click)="downloadReport(true)"
        ></gl-menu-item>
      </gl-context-menu>
    </lms-toolbar>
  </div>
  <div *ngIf="view === 'federations'">
    <lms-toolbar [options]="toolbarConfig" (clickDownload)="downloadReport()">
      <gl-context-menu medium>
        <gl-button slot="target" icon icon-center="glicon-download"> </gl-button>
        <gl-menu-item
          [text]="'kepler.ranking.rankingExportCurrentList' | translate"
          (click)="downloadReport()"
        ></gl-menu-item>
        <gl-menu-item
          [text]="'kepler.ranking.rankingExportAllList' | translate"
          (click)="downloadReport(true)"
        ></gl-menu-item>
      </gl-context-menu>
    </lms-toolbar>
  </div>
  <div id="ranking-selector" class="gl-table__tabs" *ngIf="!isAnyFederationSelected">
    <div class="gl-table__tabs--selector" *ngIf="view === 'groups' && match.groups?.length">
      <gl-select
        small
        [value]="groupFilterSelected"
        [options]="groupFilterOptions"
        (onChange)="onSelectorChange($event.detail.value)"
      ></gl-select>
      <gl-tooltip posTop [text]="tooltipRankingFilterText"></gl-tooltip>
    </div>
    <div class="gl-table__tabs--selector" *ngIf="view === 'federations' && match.groups?.length">
      <gl-select
        small
        [value]="federationFilterSelected"
        [options]="federationFilterOptions"
        (onChange)="onFederationSelectorChange($event.detail.value)"
      ></gl-select>
      <gl-tooltip posTop [text]="'kepler.league.tootlipSelect' | translate"></gl-tooltip>
    </div>
    <div class="gl-table__tabs--item" [ngClass]="{ active: view === 'groups' }" (click)="selectRanking('groups')">
      {{ 'kepler.ranking.single' | translate }}
    </div>
    <div
      *ngIf="match.federations?.length"
      class="gl-table__tabs--item"
      [ngClass]="{ active: view === 'federations' }"
      (click)="selectRanking('federations')"
    >
      {{ 'kepler.ranking.federations' | translate }}
    </div>
  </div>
  <div *ngIf="view === 'groups'; else federationsTemplate">
    <lms-kepler-group-ranking-list #groupRanking [options]="options" [match]="match"></lms-kepler-group-ranking-list>
  </div>
  <ng-template #federationsTemplate>
    <lms-kepler-federation-ranking-list
      (openModal)="openAddFederationModal()"
      (isAnySelectedChange)="isAnyFederationSelected = $event"
      (selectedFederationRankings)="selectedFederationRankings = $event"
      #federationsRanking
      [options]="options"
    ></lms-kepler-federation-ranking-list>
  </ng-template>
  <lms-modal #addFederations size="small">
    <div class="gl-popup__close" (click)="closeFederationModal()">
      <span class="glicon-close"></span>
    </div>
    <div class="gl-popup__title">{{ 'kepler.league.addFederationsTitle' | translate }}</div>
    <div class="margin-top-16">
      <lms-dynamic-form
        [questions]="leagueQuestions"
        [options]="{ disableCard: true, submitLabel: 'actions.add' }"
        (submit)="addFederation($event)"
      >
        <gl-button
          color-secondary
          [text]="'actions.cancel' | translate"
          (onClick)="closeFederationModal()"
          form-actions-before
        ></gl-button>
      </lms-dynamic-form>
    </div>
  </lms-modal>
</div>
